export const getCompaniesList = (state) => state.permissions.companies
